module.exports = __webpack_public_path__ + "static/media/twitter.680f6bb9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CanvasPublished/twitter.svg
// module id = 694
// module chunks = 0